// components/Registration/FamilyDetailsStep.js
import React from "react";
import { TextField } from "@mui/material";
import Autocomplete from "@material-ui/lab/Autocomplete";

export default function FamilyDetailsStep({ formData, setFormData, validateError }) {
  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({ ...prev, [name]: value }));
  };

  const handleBrotherOccupationChange = (index, newValue) => {
    const newOccupations = [...formData.brother_occupations];
    newOccupations[index] = newValue?.value || "";
    setFormData(prev => ({ ...prev, brother_occupations: newOccupations }));
  };

  const handleSisterOccupationChange = (index, newValue) => {
    const newOccupations = [...formData.sister_occupations];
    newOccupations[index] = newValue?.value || "";
    setFormData(prev => ({ ...prev, sister_occupations: newOccupations }));
  };

  // Initialize arrays for occupations if they don't exist
  if (!formData.brother_occupations) {
    formData.brother_occupations = Array(Number(formData.brother) || 0).fill("");
  }
  if (!formData.sister_occupations) {
    formData.sister_occupations = Array(Number(formData.sister) || 0).fill("");
  }

  const occupationOptions = [
    { title: "Student", value: "Student" },
    { title: "Employed", value: "Employed" },
    { title: "Self-Employed", value: "Self-Employed" },
    { title: "Unemployed", value: "Unemployed" },
    { title: "Business", value: "Business" },
    { title: "Retired", value: "Retired" },
    { title: "Homemaker", value: "Homemaker" },
    { title: "Others", value: "Others" },
  ];
  return (
    <div>
      <TextField fullWidth label="Father's Name" name="father_name" value={formData.father_name} onChange={handleChange} error={!!validateError.father_name} helperText={validateError.father_name}
        FormHelperTextProps={{
          style: { fontSize: "14px", color: "red" },
        }}
        sx={{
          '& .MuiInputBase-input': {
            fontSize: '16px',
          }
        }}
        InputLabelProps={{
          sx: {
            ".MuiInputLabel-asterisk": {
              color: "red",
              fontSize: "1.2em",
            }
          }
        }}
        required
        style={{ margin: "1em" }} />
      <TextField fullWidth label="Mother's Name" name="mother_name" value={formData.mother_name} onChange={handleChange} error={!!validateError.mother_name} helperText={validateError.mother_name}
        FormHelperTextProps={{
          style: { fontSize: "14px", color: "red" },
        }}
        sx={{
          '& .MuiInputBase-input': {
            fontSize: '16px',
          }
        }}
        InputLabelProps={{
          sx: {
            ".MuiInputLabel-asterisk": {
              color: "red",
              fontSize: "1.2em",
            }
          }
        }}
        required
        style={{ margin: "1em" }} />
      <TextField fullWidth label="Father's Occupation" name="dad_work" value={formData.dad_work} onChange={handleChange} error={!!validateError.dad_work} helperText={validateError.dad_work}
        FormHelperTextProps={{
          style: { fontSize: "14px", color: "red" },
        }}
        sx={{
          '& .MuiInputBase-input': {
            fontSize: '16px',
          }
        }}
        InputLabelProps={{
          sx: {
            ".MuiInputLabel-asterisk": {
              color: "red",
              fontSize: "1.2em",
            }
          }
        }}
        required
        style={{ margin: "1em" }} />
      <TextField fullWidth label="Mother's Occupation" name="mom_work" value={formData.mom_work} onChange={handleChange} error={!!validateError.mom_work} helperText={validateError.mom_work}
        FormHelperTextProps={{
          style: { fontSize: "14px", color: "red" },
        }}
        style={{ margin: "1em" }}
        sx={{
          '& .MuiInputBase-input': {
            fontSize: '16px',
          }
        }}
        InputLabelProps={{
          sx: {
            ".MuiInputLabel-asterisk": {
              color: "red",
              fontSize: "1.2em",
            }
          }
        }}
        required />
      <TextField fullWidth label="Number of Brothers" name="brother" value={formData.brother} onChange={handleChange} error={!!validateError.brother} helperText={validateError.brother} FormHelperTextProps={{
        style: { fontSize: "14px", color: "red" },
      }}
        sx={{
          '& .MuiInputBase-input': {
            fontSize: '16px',
          }
        }}
        InputLabelProps={{
          sx: {
            ".MuiInputLabel-asterisk": {
              color: "red",
              fontSize: "1.2em",
            }
          }
        }}
        required
        style={{ margin: "1em" }} />
      <TextField fullWidth label="Married Brothers" name="m_brother" value={formData.m_brother} onChange={handleChange} error={!!validateError.m_brother} helperText={validateError.m_brother} FormHelperTextProps={{
        style: { fontSize: "14px", color: "red" },
      }}
        sx={{
          '& .MuiInputBase-input': {
            fontSize: '16px',
          }
        }}
        InputLabelProps={{
          sx: {
            ".MuiInputLabel-asterisk": {
              color: "red",
              fontSize: "1.2em",
            }
          }
        }}
        required
        style={{ margin: "1em" }} />
      {/* <TextField fullWidth label="Number of Sisters" name="sister" value={formData.sister} onChange={handleChange} style={{ margin: "1em" }} />
      <TextField fullWidth label="Married Sisters" name="m_sister" value={formData.m_sister} onChange={handleChange} style={{ margin: "1em" }} /> */}
      {/* Brothers' Occupations */}
      {Array.from({ length: Number(formData.brother) || 0 }).map((_, index) => (
        <div key={`brother-${index}`} style={{ margin: "1em" }}>
          <Autocomplete
            options={occupationOptions}
            getOptionLabel={(option) => option.title}
            onChange={(event, newValue) => handleBrotherOccupationChange(index, newValue)}
            value={formData.brother_occupations[index] ? { title: formData.brother_occupations[index], value: formData.brother_occupations[index] } : null}
            renderInput={(params) => (
              <TextField
                {...params}
                label={`Brother ${index + 1} Occupation`}
                variant="outlined"
                error={!!validateError.m_brother}
                helperText={validateError.m_brother}
                FormHelperTextProps={{
                  style: { fontSize: "14px", color: "red" },
                }}
                sx={{
                  '& .MuiInputBase-input': {
                    fontSize: '16px',
                  }
                }}
              />
            )}
          />
        </div>
      ))}

      <TextField fullWidth label="Number of Sisters" name="sister" value={formData.sister} onChange={handleChange} error={!!validateError.sister} helperText={validateError.sister} FormHelperTextProps={{
        style: { fontSize: "14px", color: "red" },
      }}
        sx={{
          '& .MuiInputBase-input': {
            fontSize: '16px',
          }
        }}
        InputLabelProps={{
          sx: {
            ".MuiInputLabel-asterisk": {
              color: "red",
              fontSize: "1.2em",
            }
          }
        }}
        required
        style={{ margin: "1em" }} />
      <TextField fullWidth label="Married Sisters" name="m_sister" value={formData.m_sister} onChange={handleChange} error={!!validateError.m_sister} helperText={validateError.m_sister} FormHelperTextProps={{
        style: { fontSize: "14px", color: "red" },
      }}
        sx={{
          '& .MuiInputBase-input': {
            fontSize: '16px',
          }
        }}
        InputLabelProps={{
          sx: {
            ".MuiInputLabel-asterisk": {
              color: "red",
              fontSize: "1.2em",
            }
          }
        }}
        required
        style={{ margin: "1em" }} />

      {/* Sisters' Occupations */}
      {Array.from({ length: Number(formData.sister) || 0 }).map((_, index) => (
        <div key={`sister-${index}`} style={{ margin: "1em" }}>
          <Autocomplete
            options={occupationOptions}
            getOptionLabel={(option) => option.title}
            onChange={(event, newValue) => handleSisterOccupationChange(index, newValue)}
            value={formData.sister_occupations[index] ? { title: formData.sister_occupations[index], value: formData.sister_occupations[index] } : null}
            renderInput={(params) => (
              <TextField
                {...params}
                label={`Sister ${index + 1} Occupation`}
                variant="outlined"
                error={!!validateError.m_sister}
                helperText={validateError.m_sister}
                FormHelperTextProps={{
                  style: { fontSize: "14px", color: "red" },
                }}
                sx={{
                  '& .MuiInputBase-input': {
                    fontSize: '16px',
                  }
                }}
              />
            )}
          />
        </div>
      ))}
      <TextField fullWidth label="Native Place" name="native_place" value={formData.native_place} onChange={handleChange} error={!!validateError.native_place} helperText={validateError.native_place}
        FormHelperTextProps={{
          style: { fontSize: "14px", color: "red" },
        }}
        sx={{
          '& .MuiInputBase-input': {
            fontSize: '16px',
          }
        }}
        InputLabelProps={{
          sx: {
            ".MuiInputLabel-asterisk": {
              color: "red",
              fontSize: "1.2em",
            }
          }
        }}
        required
        style={{ margin: "1em" }} />

      <TextField
        fullWidth label="Dowry"
        name="dever" value={formData.dever}
        onChange={handleChange}
        error={!!validateError.dever}
        helperText={validateError.dever}
        FormHelperTextProps={{
          style: { fontSize: "14px", color: "red" },
        }}
        sx={{
          '& .MuiInputBase-input': {
            fontSize: '16px',
          }
        }}
        style={{ margin: "1em" }} />

      <TextField
        fullWidth label="Assets"
        name="peroparty" value={formData.peroparty}
        onChange={handleChange}
        error={!!validateError.peroparty}
        helperText={validateError.peroparty}
        FormHelperTextProps={{
          style: { fontSize: "14px", color: "red" },
        }}
        sx={{
          '& .MuiInputBase-input': {
            fontSize: '16px',
          }
        }}
        style={{ margin: "1em" }} />
    </div >
  );
}
